import React, { useState, useEffect, useRef, useMemo } from "react";

import { Form,ProgressBar } from "react-bootstrap";
import { base, s3base } from "api.js";
import Sound from 'react-sound';
import "components/custom.css";
import { store, persistor } from 'store/index';
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
// import TagIcon1 from "assets/images/images_new/tag1.svg";
import TimeUp from "components/PracticeMaterial/PopUps/TimeUp";
import ClockIcon from "assets/images/images_new/clock_1.png";

const LIMIT = 480; // 8 minutes.
// const LIMIT = 10; // 10 seconds. testing only.

const Summer = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  // const [isBlocked, setIsBlocked] = useState(false);
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [secondCount1, setSecondCount1] = useState(LIMIT);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId1, setIntervalId1] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [lang, setLang] = useState(store.getState().user.lang);
  const [soundStatus, setSoundStatus] = useState(true);
  const [content, setContent] = useState('');
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(90);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [newQue, setNewQue] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const [question_audio, setQuestion_audio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [inputRows, setInputRows] = useState(1);
  const [scrollHeight, setScrollHeight] = useState(0);

  const intervalIdRef = useRef(intervalId);
  const intervalId1Ref = useRef(intervalId1);

  // console.log("inside summarize spoken test");
  

  useEffect(() => {
    intervalIdRef.current = intervalId;
  }, [intervalId]);

  useEffect(() => {
    intervalId1Ref.current = intervalId1;
  }, [intervalId1]);

  const selectAndTryAudio = (index) => {
    const { question_audios } = props.data;
    if (question_audios && question_audios.length > 0 && index < question_audios.length) {
      const selected = question_audios[index];
      setQuestion_audio(`${s3base}/${selected.value}`);
      setDefaultSelectedVoice(selected.label);
      setCurrentAudioIndex(index);
    }
  };

  const handleAudioError = (errorCode, description) => {
    console.log("Got the error", errorCode, description);
    const { question_audios, media_link } = props.data;
    
    if (!question_audios || question_audios.length === 0) {
      console.error("No alternative audio available, using media_link");
      setQuestion_audio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      return;
    }

    if (audioRetryCount >= question_audios.length) {
      console.error("All audios failed, falling back to media_link");
      setQuestion_audio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      setAudioRetryCount(0);
      return;
    }

    const nextIndex = (currentAudioIndex + 1) % question_audios.length;
    setAudioRetryCount(prevCount => prevCount + 1);
    setSoundKey(prevKey => prevKey + 1);
    
    setTimeout(() => {
      selectAndTryAudio(nextIndex);
    }, 100);
  };

  // ComponentDidMount
  useEffect(() => {
    console.log("This is the Summary text in listening")
    if (!props.answer) {
      // select audio.
      let question_audio_temp = null;
      let defaultSelectedVoice_temp = null;
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio_temp = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoice_temp = question_audios[x].label;
        setCurrentAudioIndex(x);
        setAudioRetryCount(0);
      } else {
        const { media_link } = props.data;
        question_audio_temp = `${s3base}${media_link}`;
      }

      setQuestion_audio(question_audio_temp);
      setDefaultSelectedVoice(defaultSelectedVoice_temp);
      props.updateQuestionAudioUrlInPractice(question_audio_temp);
    }

    const { isQuestionTime, questionTime } = props;
    if (isQuestionTime) {
      setSecondCount1(questionTime * 60);
      setShowTimer(isQuestionTime);
    }

    const newIntervalId = setInterval(timer, 1000);
    const newIntervalId1 = setInterval(timer1, 1000);
    setIntervalId(newIntervalId);
    setIntervalId1(newIntervalId1);

    return () => {
      clearInterval(newIntervalId);
      clearInterval(newIntervalId1);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(intervalId1Ref.current);
        clearInterval(recordId);

        let question_audio_temp = null;
        let defaultSelectedVoice_temp = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio_temp = `${s3base}/${question_audios[x].value}`;
          defaultSelectedVoice_temp = question_audios[x].label;
          setCurrentAudioIndex(x);
          setAudioRetryCount(0);
        } else {
          const { media_link } = props.data;
          question_audio_temp = `${s3base}${media_link}`;
        }

        const { isQuestionTime, questionTime } = props;
        let secondState = { secondCount1Val: 600, showTimerVal: false };
        if (isQuestionTime) {
          secondState = {
            secondCount1Val: questionTime * 60,
            showTimerVal: isQuestionTime,
          };
        }

        setNewQue(true);
        setTimeoutStat(false);
        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setContent('');
        setIsRecording(false);
        setSecondCount(10);
        setSecondCount1(secondState.secondCount1Val);
        setShowTimer(secondState.showTimerVal);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
        setQuestion_audio(question_audio_temp);
        setDefaultSelectedVoice(defaultSelectedVoice_temp);
      } else {
        if (!questionId) {
          setContent('');
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart, questionId, recordId]);

  const skip = () => {
    clearInterval(intervalIdRef.current);
    setSecondCount(0);
  };

  // const stopTest = () => {
  //   props.nextQuestion({ ...resultObj, time: secondCount1 });
  // };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  // const cutToClipboard = () => {
  //   document.execCommand("cut");
  // };

  // const pasteToClipboard = async () => {
  //   alert("Press Ctrl+v for paste text");
  // };

  const timer = () => {
    setSecondCount(prev => {
      if (prev <= 1) {
        clearInterval(intervalIdRef.current);
      return 0
      }
      return prev - 1;
    });
  };

  const timer1 = () => {
    const { answer, nextQuestionHandler } = props;

    setSecondCount1(prevSecondCount1 => {
      let newSecondCount1 = prevSecondCount1;

      // keep running timer if question is not submitted.
      if (!answer) {
        if (prevSecondCount1 === 1) {
          clearInterval(intervalId1Ref.current);
          setTimeoutStat(true);
          setIsOpen(true);

          if (showTimer) {
            nextQuestionHandler();
          }
        }
        newSecondCount1 = prevSecondCount1 - 1;
      } else {
        // clear interval.
        clearInterval(intervalId1Ref.current);
      }

      return newSecondCount1;
    });
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    props.soundChecked();
    props.showResult();
    if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const stopAudio = () => {
    setSoundStatus(false);
    if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const handleTextareaSize = (e) => {
    const textarea = e.target;

    const maxHeight = 241;

    textarea.style.height = "auto";

    if (textarea.scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + "px";
      textarea.style.overflowY = "auto"; // show scrollbar
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden"; // hide scrollbar
    }
  };

  const chaneText = (e) => {
    let { name, value } = e.target;
    const hasContent = value.trim().length > 0; 
    console.log(hasContent);
    props.submit({
      'answer': value,
      'correct': '',
      'length': value.split(' ').filter(function (n) { return n != '' }).length,
      time: secondCount1,
      lang: lang
    }, hasContent);

    setContent(value);
    setResultObj({
      'answer': value,
      'correct': '',
      'length': value.split(' ').filter(function (n) { return n != '' }).length,
      time: secondCount1,
      lang: lang
    });
  };

  const updateCorrect = () => {
    props.submit({
      'answer': '',
      'correct': '',
      'length': content.split(' ').filter(function (n) { return n != '' }).length,
      time: secondCount1,
      lang: lang
    });

    setCorrectFlag(false);
    setResultObj({
      'answer': '',
      'correct': '',
      'length': content.split(' ').filter(function (n) { return n != '' }).length,
      time: secondCount1,
      lang: lang
    });
  };

  const newQuesFunc = () => {
    const newIntervalId1 = setInterval(timer1, 1000);
    setIntervalId1(newIntervalId1);
    setNewQue(false);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevState => prevState + 1);
    setPlaybackSpeed(speed);
  };

  const changeAudio = (selected) => {
    clearInterval(intervalId1Ref.current);

    setIntervalId1(0);

    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestion_audio(`${s3base}/${selected_audio[0].value}`);
  };

  const playingQuestionSectionLabel = () => {
    let status = '';
    if (props.answer) {
    return 'Question audio finished.';
  }
    if (!isRecording) {
      if (secondCount !== 0 && soundStatus === true) {
        status = `Beginning in ${secondCount} seconds`;
      } else if (secondCount === 0 && soundStatus) {
        status = 'Playing question audio...';
      } else {
        status = 'Question audio finished.';
      }
    } else {
      status = 'Question audio finished.';
    }
    return status;
  };

  // console.log("secondCount==",secondCount);
  

  const showSkipAudioWaitButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount !== 0 && blobURL === '' && !isRecording) {
      button = true;
    }

    return button;
  };

  const showSkipAudioButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount === 0 && soundStatus === true && !isRecording) {
      button = true;
    }

    return button;
  };

  const timeLeft = () => {
    if(answer){
      clearInterval(intervalId1Ref.current);
    }
    const totalSeconds = Math.max(0, Math.floor(secondCount1));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return ` ${minutes}:${seconds.toString().padStart(2, "0")}`
    // return `${Math.floor(secondCount1 / 60)}m : ${secondCount1 % 60}s`;
  };

  const wordCount = () => {
    return content === "" ? 0 : content.trim().split(/\s+/).length;
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  // Handle reset effect
  useEffect(() => {
    if (reset) {
      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setReset(false);
    }
  }, [reset]);

  // Handle newQue effect
  useEffect(() => {
    if (newQue) {
      newQuesFunc();
    }
  }, [newQue]);

  // let questionText = "";
  //  if (props.data) {
  //   questionText = props.data.question; 
  // }

  // if (props.restart) {
  //   props.restartQue();
  // }

  let questionText = useMemo(() => {
  return props.data?.question || "";
}, [props.data?.question]);

useEffect(() => {
  if (props.restart) {
    props.restartQue();
  }
}, [props.restart, props.restartQue]);

  // if (props.stopRecording) {
  //   stopTest();
  // }

 useEffect(() => {
  if (props.data && correctFlag) {
    updateCorrect();
  }
}, [props.data, correctFlag]);


  const { data, resultMode, answer, showResponse } = props;

  useEffect(() => {
    if (answer && intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  }, [answer]);

  return (
    <>
      {data && !resultMode && soundStatus && secondCount === 0 && question_audio &&
        <Sound
          url={question_audio}
          playStatus={answer || !props.soundStatusMain ? Sound.status.STOPPED : Sound.status.PLAYING}
          onFinishedPlaying={handleSongFinishedPlaying}
          onPlaying={handleSongPlaying}
          onError={handleAudioError}
          volume={volume}
          playbackRate={playbackSpeed}
          key={soundKey}
        />
      }

      <div className="pmw-tabs-section d-flex align-items-start justify-content-center pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible mx-0">
        {/* <div className="recorded-section h-100 width-25" width-50></div> */}
        <div className="recorded-section h-100 m-0 p-0 border-0">
          <div className="recorded-content">
            <div className="row">
              <div className="col-12">
                <ul className="recorded-list">
                  <li>Status:</li>
                  <li>{playingQuestionSectionLabel()}</li>
                </ul>
              </div>
              {/* <div className="col-4">
                <span className="volume-label">Volume</span>
              </div> */}
            </div>
            <div className="recorded-audio-wrapper">
              <div className="mt-3 clearfix">
                <div className="row">
                  <div className="col-10 col-sm-11">
                    <ProgressBar now={(soundPer)} striped />
                  </div>

                  <div className="col-1">
                    <div className="volume-control-wrapper">
                      <span className="volume-icon">
                        <i className="fa fa-volume-up" aria-hidden="true"></i>
                      </span>
                      <div className="re-volume-wrapper-horizontal">
                        <input
                          type="range"
                          placeholder="Volume"
                          className="volume-control"
                          min="0"
                          max="100"
                          step="1"
                          defaultValue={volume}
                          onInput={(e) => changeRange(e)}
                          style={{
                            "--progress": `${(volume / 100) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mt-2 px-0">

                    <div className="pull-left">
                      <PlaybackSpeedBtns
                        answer={props.answer}
                        sound = {soundStatus}
                        changePlaybackSpeed={changePlaybackSpeed}
                        playbackSpeed={playbackSpeed}
                        />
                    </div>
                    {defaultSelectedVoice !== null && !props.answer &&
                      <div className="mx-1 pull-left visibility-visible">
                        <SelectVoiceDropDown
                        answer={props.answer}
                        sound={soundStatus}
                          voices={props.voices}
                          selected={defaultSelectedVoice}
                          changeAudio={changeAudio}
                        />
                      </div>
                    }

                    {showSkipAudioWaitButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={skip}
                        >Start Audio</a>
                      </div>
                    }

                    {showSkipAudioButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={stopAudio}
                        >Stop Audio</a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="editor-wrapper-section custom-box mx-0">
        <div className="editor-wrapper">
          <div className="editor__toolbar">
            <button className="toolbar__button"></button>
          </div>
          <div className="editor__input">
            {!timeoutStat && !answer ? (
              <Form.Control
                as="textarea"
                className="writing-textarea"
                onCopy={copyToClipboard}
                autoCorrect="false"
                spellCheck="false"
                name="content"
                onChange={(e) => { chaneText(e) }}
                onKeyUp={handleTextareaSize}
                value={content}
                placeholder="Write your response here"
              />
            ) : (
              <div style={{
                whiteSpace: 'pre-line'
              }}>{content}</div>
            )}
          </div>
        </div>
        <div className="mt-3 clearfix sm-flex">
          <div className="time-spent pull-left">
            <img src={ClockIcon} alt="Badge" /><span>Time Left:{" "}</span> {timeLeft()}
          </div>

          <div className="word-count pull-right">
            <span>Total word count:</span> {wordCount()}
          </div>
        </div>
      </div>

      {
        !answer &&
        <TimeUp
        isOpen={isOpen}
        toggle={toggle}
        title="Time up !!!"
        message="You have used up all your allotted time for this question."
        buttonLabel="Submit Now"
        showResponse={showResponse}
        allowClose={true}
        submitDisable={props.submitDisable}
      />
      }
    </>
  );
};

export default Summer;